<app-case-medical [processingClassSubtype]="processingClassSubType.Hospital"></app-case-medical>
